var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgApple(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 44,
    height: 44,
    viewBox: "0 0 44 44",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_307_7440)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M44 0H0V44H44V0Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.2227 14.3846C23.0547 14.3846 24.0977 13.8048 24.7188 13.0318C25.2812 12.3312 25.6914 11.3528 25.6914 10.3744C25.6914 10.2416 25.6797 10.1087 25.6562 10C24.7305 10.0362 23.6172 10.6402 22.9492 11.4495C22.4219 12.0655 21.9414 13.0318 21.9414 14.0223C21.9414 14.1672 21.9648 14.3121 21.9766 14.3605C22.0352 14.3725 22.1289 14.3846 22.2227 14.3846ZM19.293 29C20.4297 29 20.9336 28.2149 22.3516 28.2149C23.793 28.2149 24.1094 28.9758 25.375 28.9758C26.6172 28.9758 27.4492 27.7921 28.2344 26.6325C29.1133 25.3039 29.4766 23.9994 29.5 23.939C29.418 23.9148 27.0391 22.9123 27.0391 20.0979C27.0391 17.658 28.9141 16.5588 29.0195 16.4743C27.7773 14.6383 25.8906 14.59 25.375 14.59C23.9805 14.59 22.8438 15.4596 22.1289 15.4596C21.3555 15.4596 20.3359 14.6383 19.1289 14.6383C16.832 14.6383 14.5 16.595 14.5 20.2912C14.5 22.5861 15.3672 25.014 16.4336 26.5842C17.3477 27.9129 18.1445 29 19.293 29Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_307_7440"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 44,
    height: 44,
    rx: 22,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgApple);
export default __webpack_public_path__ + "static/media/Apple.bf0e6dcea2729f10b825a166825d8c9c.svg";
export { ForwardRef as ReactComponent };